module.exports = __webpack_public_path__ + "img/中国光大银行.ad0008e9.png";